var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistoryBtnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.01318 8.72671V9.06005C1.01318 13.1667 4.36652 16.4934 8.50652 16.4934C12.6465 16.4934 15.9999 13.1667 15.9999 9.06005C15.9999 4.95338 12.6399 1.62005 8.49985 1.62005C7.07985 1.62005 4.49985 2.16671 2.83318 4.33338M8.43985 5.00005C8.43985 5.00005 8.19318 8.38005 8.43985 9.05338C8.68652 9.72671 11.1665 11.76 11.1665 11.76M5.66652 4.82671C4.48652 4.90005 2.67985 5.06671 2.36652 4.70671C2.05318 4.34671 2.31985 2.38671 2.42652 1.50671",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryBtnIcon);
export default __webpack_public_path__ + "static/media/history-btn-icon.d168969abbc2f87e96e951b1b127353e.svg";
export { ForwardRef as ReactComponent };